// Jobs registry — the single source of truth for /careers and the
// role detail pages. Add a new role by appending an object below
// (no other code changes needed). Take a role down by switching
// `status` to "closed".

export const CAREERS_EMAIL = "shvetha@orani.studio";

const JOBS = [
  {
    slug: "junior-designer",
    title: "Junior Designer",
    department: "Design Studio",
    location: "Bangalore",
    type: "Full-time",
    experience: "2–3 years",
    metaOverride: "2–3 years experience · Bangalore · Full-time",
    status: "open",
    listingSummary:
      "For someone ready to move beyond collecting beautiful references and start understanding how thoughtful spaces are actually made.",
    heroIntro: [
      "This role is for someone ready to move beyond collecting beautiful references and start understanding how thoughtful spaces are actually made.",
      "You will work closely with the founders and studio team across live projects, seeing how ideas become drawings, site decisions, styling, and finished spaces.",
      "We do not expect you to have all the answers. We are looking for someone who notices carefully, takes responsibility, asks good questions, and wants to grow through the work.",
    ],
    sections: [
      {
        title: "You\u2019ll fit right in if you\u2026",
        bullets: [
          "care about making a presentation sheet feel just right.",
          "can stay attentive when execution gets unpredictable.",
          "enjoy being on site as much as working at the desk.",
          "can move between creative thinking and practical coordination.",
          "are curious about how a space is experienced, not just how it looks.",
          "get genuinely excited by detail \u2014 lineweights, material junctions, light, proportion.",
          "want to understand how good spaces come together, from the first sketch to the final layer.",
        ],
      },
      {
        title: "What you\u2019ll learn by being here",
        bullets: [
          "how a project moves from first idea to site work, styling, and handover.",
          "how to carry a project from first thought to final layer, and grow into owning the full project arc.",
          "how to turn references and moodboards into decisions that can actually be built.",
          "how design changes when it meets materials, timelines, vendors, and the realities of site.",
          "how to make decisions without losing the design intent.",
          "how design can shape not just a room, but the way people move through, use, remember, and experience a place.",
        ],
      },
      {
        title: "Your role will include",
        bullets: [
          "preparing mood boards, presentation sheets, and material palettes.",
          "creating drawings, layouts, and design documentation.",
          "coordinating with vendors, consultants, and execution teams.",
          "sourcing materials, furniture, lighting, and finishes.",
          "assisting during site visits, styling, and project coordination.",
          "supporting multiple live projects as they move from idea to execution.",
        ],
      },
      {
        title: "Tools we work with",
        intro:
          "Good design needs clear communication. You should be able to express ideas through drawings, presentations, references, and visual studies.",
        bullets: [
          "AutoCAD",
          "Lumion / V-Ray",
          "Adobe Creative Suite",
          "SketchUp or any 3D modelling workflow",
          "AI tools, when they genuinely help the work.",
        ],
      },
    ],
    applyMode: "tally",
    applyUrl: "https://tally.so/r/QKzMvp",
    questionsEmail: CAREERS_EMAIL,
  },
  {
    slug: "design-intern",
    title: "Design Intern",
    department: "Design Studio",
    location: "Bangalore",
    type: "Internship",
    experience: "Student / Recent Graduate",
    metaOverride:
      "Recent architecture / interior design graduate \u00b7 Bangalore \u00b7 Full-time",
    status: "open",
    listingSummary:
      "For someone at the beginning of their design journey, ready to learn how a studio works from the inside.",
    heroIntro: [
      "This role is for someone at the beginning of their design journey, ready to learn how a studio works from the inside.",
      "You will support the team across live projects \u2014 helping with presentations, drawings, sourcing, documentation, site visits, and the day-to-day details that keep a project moving.",
      "What matters most is attention, curiosity, organisation, and the willingness to stay close to the work.",
    ],
    sections: [
      {
        title: "You\u2019ll fit right in if you\u2026",
        bullets: [
          "care about making things clear, neat, and thoughtfully presented.",
          "have a good eye for layouts, references, materials, and visual composition.",
          "enjoy understanding how spaces come together behind the scenes.",
          "can move between studio tasks and site realities with a good attitude.",
          "are curious about why some spaces stay with you, even before you know how to explain them.",
          "are comfortable learning new tools, asking questions, and improving quickly.",
        ],
      },
      {
        title: "What you\u2019ll learn by doing",
        bullets: [
          "how to turn observations, references, and moodboards into useful design inputs.",
          "how drawings, materials, vendors, and site decisions connect in a live project.",
          "how good spaces are built through both creative thinking and everyday follow-through.",
          "how to help with presentations, documentation, sourcing, samples, site visits, and styling.",
          "how to start seeing beyond the image of a space \u2014 into how it is used, felt, and remembered.",
        ],
      },
      {
        title: "Tools we work with",
        intro:
          "Good design also needs clear communication. You should be able to share ideas through drawings, references, presentation sheets, and visual studies.",
        bullets: [
          "AutoCAD",
          "SketchUp / Lumion / V-Ray",
          "Adobe Creative Suite",
          "AI tools, when they genuinely help the work.",
        ],
      },
    ],
    applyMode: "tally",
    applyUrl: "https://tally.so/r/GxqpOo",
    questionsEmail: CAREERS_EMAIL,
  },
];

export const getAllJobs = () => JOBS;
export const getOpenJobs = () => JOBS.filter((j) => j.status === "open");
export const getJob = (slug) => JOBS.find((j) => j.slug === slug) || null;
